<template>
  <header class='breadcrumb ct-flex-row'>
    <ul class='ct-flex-row item-flex-full'>
      <li>
        <router-link :to='{ name : "exploitations"}'>Accueil</router-link>
      </li>
      <li v-for='(route,index) in routes' :key='index'>
        <router-link :to='{ name : getRouteName(route) , params : params}'>{{ getLabel(route) }}</router-link>
      </li>
    </ul>
    <slot />
  </header>
</template>

<script>
export default {
  name: 'Breadcrumb',

  computed: {
    routes () {
      return this.$route.matched.filter(r => !r.meta || r.meta.breadcrumb !== false)
    },
    params () {
      return this.$route.params
    }
  },

  methods: {
    getLabel (route) {
      let bc = route.meta && route.meta.breadcrumb
      if (bc) {
        if (bc.getter) {
          let getter = this.$store.getters[bc.getter]
          if (bc.params) {
            let params = this.params[bc.params]
            return getter(params)
          }
          return getter
        }
        if (bc.text) {
          return bc.text
        }
      }
      return route.name
    },
    getRouteName (route) {
      let bc = route.meta && route.meta.breadcrumb
      if (bc && bc.routeName) {
        return bc.routeName
      }
      return route.name
    }
  }

}
</script>
